<template>
  <SelectComponent
    v-model="localFrom"
    :label="$t('global.email_from')"
    name="from"
    :values="validFrom"
    display-key="label_select"
    :disabled="disabled"
    :required="required"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'

export default {
  name: 'SelectEmailFromAddress',
  components: { SelectComponent },
  props: {
    from: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['update:from'],
  computed: {
    ...mapGetters({
      auth: 'auth/getAuth',
      funeral_homes: 'metadata/getFuneralHomesMetadata',
      allUsers: 'metadata/getAllUsersMetadata'
    }),
    localAuth() {
      return this.allUsers.find((user) => user.id === this.auth.id)
    },
    validFrom() {
      return [
        {
          id: this.localAuth.id,
          name: this.localAuth.full_name,
          type: 'App\\Models\\User',
          emailable: this.localAuth.email,
          label_select: `${this.localAuth.full_name} - ${this.localAuth.email}`,
          disabled: this.localAuth.email.length === 0,
          signature: this.localAuth.email_signature,
            // this.localAuth.signature_html_enabled &&
            // this.localAuth.signature_html
            //   ? this.localAuth.signature_html
            //   : this.localAuth.email_signature,
          signatures: this.localAuth.email_signatures
        },
        ...this.funeral_homes.map((funeralHome) => ({
          id: funeralHome.id,
          emailable: funeralHome.email,
          type: 'App\\Models\\FuneralHome',
          name: funeralHome.name,
          label_select: `${funeralHome.name} - ${funeralHome.email}`,
          disabled: funeralHome.email.length === 0,
          signature: funeralHome.email_signature
        }))
      ]
    },
    localFrom: {
      get() {
        return this.from?.id
      },
      set(value) {
        this.$emit(
          'update:from',
          value ? this.validFrom.find((item) => item.id === value) : null
        )
      }
    }
  }
}
</script>
